// Stimulus controller for the Email Statistics traffic chart.
// Renders a Chart.js dual-series line chart (inbound vs outbound per day).

import { Controller } from "@hotwired/stimulus"
import { I18n } from "i18n-js"
import locales from "../locales.json"
import {
  Chart,
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Legend,
  Tooltip,
  Filler,
} from "chart.js"

Chart.register(
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Legend,
  Tooltip,
  Filler
)

export default class extends Controller {
  static values = {
    labels:   Array,
    inbound:  Array,
    outbound: Array,
  }

  connect() {
    this.i18n = new I18n(locales)
    this.i18n.locale = document.querySelector("meta[name='locale']")?.content || "hu"
    this.chart = null
    this._renderChart()
  }

  disconnect() {
    this.chart?.destroy()
    this.chart = null
  }

  _renderChart() {
    const canvas = this.element.querySelector("canvas")
    if (!canvas) return

    const labels   = this.labelsValue
    const inbound  = this.inboundValue
    const outbound = this.outboundValue

    // Show fewer tick labels for wide date ranges
    const step = Math.max(1, Math.ceil(labels.length / 30))
    const displayLabels = labels.map((l, i) => (i % step === 0 ? l : ""))

    this.chart = new Chart(canvas, {
      type: "line",
      data: {
        labels: displayLabels,
        datasets: [
          {
            label: this.i18n.t("emails.statistics.filter.inbound"),
            data: inbound,
            borderColor: "rgba(59, 130, 246, 0.9)",
            backgroundColor: "rgba(59, 130, 246, 0.10)",
            borderWidth: 2,
            pointRadius: labels.length <= 31 ? 3 : 0,
            tension: 0.3,
            fill: true,
          },
          {
            label: this.i18n.t("emails.statistics.filter.outbound"),
            data: outbound,
            borderColor: "rgba(16, 185, 129, 0.9)",
            backgroundColor: "rgba(16, 185, 129, 0.10)",
            borderWidth: 2,
            pointRadius: labels.length <= 31 ? 3 : 0,
            tension: 0.3,
            fill: true,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { intersect: false, mode: "index" },
        plugins: {
          legend: { position: "bottom" },
          tooltip: {
            callbacks: {
              title: (items) => labels[items[0].dataIndex] || "",
            },
          },
        },
        scales: {
          x: { ticks: { maxRotation: 0, autoSkip: true } },
          y: { beginAtZero: true, ticks: { precision: 0 } },
        },
      },
    })
  }
}
